export const environment = {
  production: true,
  url: 'https://services.epps-erp.com:8443/eppssite/',
  mock_json: '../assets/mock-json/',
  googleMapKey: 'AIzaSyA7icjFDgKRvlTdMJ0CT3Qad70FwGR7IaM'
};
